import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { buildAppointmentStatus } from 'actions';

const moment = require('moment');

const DataRow = ({ ...props }) => {
  DataRow.propTypes = {
    appointment: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    shouldRedirect: PropTypes.bool
  };

  function getContactName (contacts) {
    if (contacts && contacts.length > 0) { return contacts[0].firstName + ' ' + contacts[0].lastName; }
  }

  function redirect (id) {
    return props.history.push('/appointmentdetails/' + id, { headerTitle: 'Appointment Details' });
  }

  const appointmentId = props.appointment.id || props.appointment.calendarEventKey;

  const shouldRedirect = props.shouldRedirect !== false;

  return (
    <div className='appointment-row' onClick={() => shouldRedirect && redirect(appointmentId)}>
      <div className='icon-container'>
        <i className='icon-calendar' />
      </div>
      <div className='appointment-details'>
        <h3>{moment(props.appointment.startDate).format('hh:mm A')} {props.appointment.name}</h3>
        <p>{getContactName(props.appointment.contacts)}</p>
      </div>
      {buildAppointmentStatus(props.appointment)}
    </div>
  );
};

export default connect((state) => { return {}; })(withRouter(DataRow));
